import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { MixpanelService } from '../services/mixpanel.service';

export type LoaderColor = 'purple' | 'green' | 'white' | 'gray' | '';

export enum TIMER_TEXT {
  '' = 0,
  'Hang tight…',
  'Almost there…',
  'Just a little longer…'
}

@Component({
  selector: 'ld-app-loader',
  templateUrl: './loader.template.html',
  styleUrls: ['./loader.style.css'],
})
export class LoaderComponent
  implements AfterViewInit, OnDestroy, OnInit {

  @Input() public size: number = 50;
  @Input() public width: number = null;
  @Input() public height: number = null;
  @Input() public color: LoaderColor = 'purple';
  @Input() public overlay: boolean = true;
  @Input() public displayText: boolean = true;
  @Input() public text: string = null;

  private componentElement: HTMLElement;
  private loaderContainer: HTMLElement;
  private intervalID: number;
  private errorSent: boolean = false;
  private timer: number = 0;
  private timerText: string = TIMER_TEXT[0];
  private scrollWatch: EventListener = () => this.moveContainer();

  private findOffset(): number {
      const scroll = document.documentElement.scrollTop || document.body.scrollTop || 0;

      const componentHeight = this.componentElement.scrollHeight || 0;
      const loaderHeight = (this.loaderContainer || { scrollHeight: 0 }).scrollHeight;
      const maxOffset = componentHeight - loaderHeight;

      return scroll > maxOffset ? maxOffset : scroll;
  }

  private moveContainer(): void {
    this.loaderContainer.style.top = this.findOffset() + 'px';
  }

  constructor(
    private element: ElementRef,
    private mixpanel: MixpanelService) {}

  ngAfterViewInit() {
    this.componentElement = this.element.nativeElement;

    if (this.componentElement.scrollHeight > window.innerHeight) {
      this.loaderContainer = this.componentElement.querySelector('.loader-container') as HTMLElement;

      this.moveContainer();
      document.addEventListener('scroll', this.scrollWatch);
    }
  }

  ngOnDestroy() {
    // Track total seconds loading if long load time
    if (this.errorSent) {
      let analyticsObj = {
        Definition: 'Borrower asked to wait for ' + this.timer + ' seconds',
        Product: 'U',
        User: 'B',
        Experience: 'E'
      };
      this.mixpanel.track('Extended Please Wait Finished UBE', analyticsObj);
    }

    clearInterval(this.intervalID);
    this.timer = 0;
    this.timerText = TIMER_TEXT[0];
    this.errorSent = false;

    document.removeEventListener('scroll', this.scrollWatch);
  }

  ngOnInit() {
    this.intervalID = (setInterval(() => { this.checkTimer(); }, 1000) as any);
  }

  checkTimer() {
    this.timer++;

    if (this.timer >= 20) {
      this.timerText = this.text || TIMER_TEXT[3];
    } else if (this.timer >= 10) {
      this.timerText = this.text || TIMER_TEXT[2];

      // Track long running loads
      if (!this.errorSent) {
        this.errorSent = true;

        let analyticsObj = {
          Definition: 'Borrower asked to wait for at least 10 seconds',
          Product: 'U',
          User: 'B',
          Experience: 'E'
        };
        this.mixpanel.track('Extended Please Wait Messaged UBE', analyticsObj);
      }
    } else if (this.timer >= 5) {
      this.timerText = this.text || TIMER_TEXT[1];
    } else {
      this.timerText = this.text || TIMER_TEXT[0];
    }
  }
}
